import React, { useState } from "react";
import { Divider, Typography, CircularProgress } from "@material-ui/core";
import moment from "moment";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { Pagination } from "@material-ui/lab";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import { useAlert } from "../../components/Alert";

const GET_FRANCHISESTORES = gql`
  query franchiseStores($latest: Boolean, $pageSize: Int, $page: Int) {
    franchiseStores(latest: $latest, pageSize: $pageSize, page: $page) {
      contents {
        id
        name
        exclusiveWeb {
          id
          url
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export default function FranchiseStoreTable({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  const [page, setPage] = useState(1);

  const { data, loading, error } = useQuery(GET_FRANCHISESTORES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      pageSize: 10,
      page: page,
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Table
            data={data?.franchiseStores.contents}
            tableWidth={2}
            header={["公司名稱", "公司專屬網址", "新增日期", "最後更新日期"]}
            columns={[
              "name",
              (item) =>
                item.exclusiveWeb?.url
                  ? "https://new.5137.com.tw/" + item.exclusiveWeb?.url
                  : null,
              (item) => moment(item.createdAt).format("yyyy-MM-DD"),
              (item) => moment(item.updatedAt).format("yyyy-MM-DD"),
            ]}
            onPress={(item) => {
              onChangeSelect(item);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                data?.franchiseStores?.pageCount !== 0
                  ? data?.franchiseStores?.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page ?? 1}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
